import React from 'react'
import axios from 'axios';
import { useEffect } from 'react';
import env from '../../env.json';

const { GOOGLE_MAP_KEY }=env;

function TestingBilling() {
    useEffect(()=>{
        getUsageInfo();
    },[])

    const getUsageInfo = async () => {
        try {
          const response = await axios.get(
            'https://cloudbilling.googleapis.com/v1/billingAccounts/01908D-17605C-F56D72/reports:cost',
            {
              headers: {
                Authorization: `Bearer ${GOOGLE_MAP_KEY}`,
              },
              params: {
                startDate: '2024-01-01',
                endDate: '2024-01-31',
                currencyCode: 'USD',
                groupBy: 'SERVICE',
                filter: 'serviceDisplayName:"Maps JavaScript API"',
              },
            }
          );
          console.log('Cost Information:', response.data);
        } catch (error) {
          console.error('Error retrieving usage information:', error);
        }
      };
  return (
    <div>TestingBilling
        <h1>TestingBilling</h1>
    </div>
  )
}

export default TestingBilling